// const ipconfig = "http://localhost:5005";
const ipconfig = "https://admin.accosync.com";
export const accosyncIpConfig = "https://accosync-test.xyz";

export default ipconfig;
